import { useEffect, useState } from "react";

export function useStoredItemsPerPage(
  storageKey: string,
  defaultValue: number
) {
  const [itemsPerPage, setItemsPerPage] = useState<number>(() => {
    const saved = localStorage.getItem(storageKey);
    return saved ? parseInt(saved, 10) : defaultValue;
  });

  useEffect(() => {
    localStorage.setItem(storageKey, itemsPerPage.toString());
  }, [itemsPerPage, storageKey]);

  return [itemsPerPage, setItemsPerPage] as const;
}
